export default "__VITE_ASSET__$E6CSLnu__"